import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})




export class DataServiceService {
  private userRole = new BehaviorSubject('');
  
  currentUserRole = this.userRole.asObservable();
  
  constructor() { }

  changeUserRole(userole: any) {
    this.userRole.next(userole)
  }

}
